
/* Only accessibility and human-readable validation. Shopify owns submission. */
(() => {
  const form = document.getElementById('GenectraArrepentimiento');
  if (!form) return;

  const result = document.getElementById('ga-errors') ||
    document.getElementById('ga-success');

  if (result) result.focus();

  form.querySelectorAll('input[required]').forEach(input => {
    input.addEventListener('input', () => input.setCustomValidity(''));

    input.addEventListener('invalid', () => {
      input.setCustomValidity('');

      if (input.validity.valueMissing) {
        input.setCustomValidity(
          input.type === 'email'
            ? 'Ingresá un correo de contacto.'
            : 'Ingresá tu nombre y apellido.'
        );
      } else if (input.validity.typeMismatch) {
        input.setCustomValidity(
          'Revisá el correo. Por ejemplo: nombre@correo.com.'
        );
      }
    });
  });
})();